import { MOSTRAR_TEXTOS_USUARIO, OCULTAR_TEXTOS_USUARIO } from './../texto-usuario/actions';

var textosUsuarioVisible = function textosUsuarioVisible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case MOSTRAR_TEXTOS_USUARIO:
      return true;

    case OCULTAR_TEXTOS_USUARIO:
      return false;

    default:
      return state;
  }
};

export default textosUsuarioVisible;